import { X } from "lucide-react";
import { sanitizeHtml } from "../lib/safeMarkdown";

/**
 * Lightweight, mobile-friendly modal used by the category page's two
 * customizable buttons. Renders admin-provided HTML content (sanitized).
 * Closes on backdrop click, Escape, or the X button.
 */
export default function CategoryButtonModal({ title, content, onClose }) {
  const html = /<[a-z][\s\S]*>/i.test(content || "")
    ? sanitizeHtml(content || "")
    : `<p>${(content || "").replace(/\n/g, "<br/>")}</p>`;
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 bg-black/70 flex items-start sm:items-center justify-center z-50 overflow-y-auto py-6 sm:py-10 px-4"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === "Escape") onClose();
      }}
      data-testid="category-button-modal"
    >
      <div
        className="bg-[#0F0F0F] border border-[#C5A059]/30 rounded-sm w-full max-w-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/5">
          <h3 className="text-lg font-serif text-white">{title}</h3>
          <button
            className="text-white/50 hover:text-white"
            onClick={onClose}
            aria-label="Close"
            data-testid="category-button-modal-close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div
          className="p-5 sm:p-6 prose-custom text-white/80 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: html }}
          data-testid="category-button-modal-content"
        />
      </div>
    </div>
  );
}
